import { render, staticRenderFns } from "./applet.vue?vue&type=template&id=01ac76b2&"
import script from "./applet.vue?vue&type=script&lang=js&"
export * from "./applet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports